module.exports = __webpack_public_path__ + "img/submitted.7980ce2.svg";